// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"am-z","categoryName":"bm-z","categoryImage":"cm-z","categoryContent":"dm-z","bottomAligned":"em-z"};